/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from "react";
import { useSelector } from "react-redux";
import "./Dashboard.css";

import {
  useEnquiryData,
  useGetBusinessData,
  useGetUserData,
} from "../../Utility";
import DashboardSkeleton from "./DashboardSkeleton";
import { Link } from "react-router-dom";

function AdminDashboard() {
  const businessData = useGetBusinessData();
  const enquiryData = useEnquiryData();
  const userData = useGetUserData();
  const usersLoading = useSelector((state) => state.userReducer?.getUsersLoading ?? false);
  const loading =
    (enquiryData?.getLoading ?? false) ||
    (businessData?.getBusinessesLoading ?? false) ||
    usersLoading;

  const stats = useMemo(
    () => ({
      totalVenues:
        businessData?.businessesList?.filter(
          (business) => business.business_type === "venue",
        ).length ?? 0,
      totalVendors:
        businessData?.businessesList?.filter(
          (business) => business.business_type === "vendor",
        ).length ?? 0,
      totalUsers:
        userData?.filter(
          (user) => user.role === "user" || user.role === "business",
        ).length ?? 0,
      totalEnquiries: enquiryData?.getData?.length ?? 0,
    }),
    [
      businessData?.businessesList,
      enquiryData?.getData,
      userData,
    ],
  );

  if (loading) {
    return <DashboardSkeleton />;
  }

  return (
    <div className="admin-dashboard">
      <div className="admin-dashboard-header">
        <h1 className="admin-dashboard-title">Dashboard</h1>
        <p className="admin-dashboard-subtitle">Welcome to the admin panel</p>
      </div>

      <div className="admin-stats-grid">
        <div className="admin-stat-card">
          <div className="admin-stat-icon">🏢</div>
          <div className="admin-stat-content">
            <div className="admin-stat-value">
              {stats.totalVenues.toLocaleString()}
            </div>
            <div className="admin-stat-label">Total Venues</div>
          </div>
        </div>

        <div className="admin-stat-card">
          <div className="admin-stat-icon">👔</div>
          <div className="admin-stat-content">
            <div className="admin-stat-value">
              {stats.totalVendors.toLocaleString()}
            </div>
            <div className="admin-stat-label">Total Vendors</div>
          </div>
        </div>

        <div className="admin-stat-card">
          <div className="admin-stat-icon">👥</div>
          <div className="admin-stat-content">
            <div className="admin-stat-value">
              {stats.totalUsers.toLocaleString()}
            </div>
            <div className="admin-stat-label">Total Users</div>
          </div>
        </div>

        <div className="admin-stat-card">
          <div className="admin-stat-icon">📅</div>
          <div className="admin-stat-content">
            <div className="admin-stat-value">
              {stats.totalEnquiries.toLocaleString()}
            </div>
            <div className="admin-stat-label">Total Enquiries</div>
          </div>
        </div>
      </div>

      <div className="admin-dashboard-content">
        <div className="admin-content-card">
          <h2 className="admin-content-title">Quick Actions</h2>
          <div className="admin-actions-grid">
              <Link to="/admin/business-users/create" className="admin-action-btn">
              <span className="admin-action-icon">➕</span>
              <span className="admin-action-label">Add Business User</span>
            </Link>
            <Link to="/admin/users/create" className="admin-action-btn">
              <span className="admin-action-icon">➕</span>
              <span className="admin-action-label">Add Admin User</span>
            </Link>
            <Link to="/admin/enquiries-users" className="admin-action-btn">
              <span className="admin-action-icon">📝</span>
              <span className="admin-action-label">Manage Enquiries</span>
            </Link>
            <Link to="/admin/users" className="admin-action-btn">
              <span className="admin-action-icon">📊</span>
              <span className="admin-action-label">View Users</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
